// Inclusive day count from screenshot 8 (SGD). Index 1 = 1 day.
export const SGD_DAY_RATES = [
  0,
  2, 3.8, 5.4, 6.8, 8, 9.3, 10.5, 11.6, 12.6, 13.5,
  14.3, 15, 15.6, 16.1, 16.5, 16.8, 17, 17.1, 17.2, 17.6,
  17.8, 18.2, 18.8, 19.4, 20, 20.5, 21, 21.5, 22, 22.5,
  22.9, 23.3, 23.7, 24.1, 24.5, 24.8, 25.1, 25.4, 25.7, 26,
  26.2, 26.4, 26.6, 26.8, 27, 27.1, 27.2, 27.3, 27.4, 27.5,
];

export const MAX_SERVICE_DAYS = 50;

export function inclusiveDays(startIso, endIso) {
  if (!startIso || !endIso) return 0;
  const start = new Date(`${startIso}T00:00:00`);
  const end = new Date(`${endIso}T00:00:00`);
  if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime()) || end < start) return 0;
  return Math.round((end - start) / 86400000) + 1;
}

export function feeForDays(days) {
  if (days < 1 || days > MAX_SERVICE_DAYS) return null;
  return SGD_DAY_RATES[days];
}

export function formatSgd(amount) {
  return `SGD ${Number(amount).toFixed(2)}`;
}
